import { render, staticRenderFns } from "./Stats2.vue?vue&type=template&id=77c31024&"
import script from "./Stats2.vue?vue&type=script&lang=js&"
export * from "./Stats2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports